import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GridContainer from '../global/GridContainer/GridContainer';


const Content = ({ homeHub }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [content, setContent] = useState('');

  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');

  useEffect(() => {
    if (id) {
      const data = homeHub.filter((item) => item.id === id)

      if (data.length > 0) {
        setContent(data[0].content);
      }
    }
  }, []);

  return (
    <div className="communities-container">
       <GridContainer>
        <div className="communities-container--upper">
          <div className="communities-container-header-back-link" onClick={() => navigate('/home')}>
            <FontAwesomeIcon
              icon={['fas', 'chevron-left']}
              className="feed-group-header-back-link-icon"
            />
            {'Go back'}
          </div>
        </div>
        <div className="pt-3">
         <p
            dangerouslySetInnerHTML={{
            __html: content
            ?.replace(/\n/g, '<br />')
            ?.replace(/<p>\s*(<br\s*\/?>)\s*<\/p>/gi, '$1'), 
          }}
        />
        </div>
       </GridContainer>
    </div>
  );
};

export default Content;
